
export enum eListCatalog {
    TypeProducts = 1,
    StatusUsers = 4,
    StatesBusiness = 15,
    StatesGroupBusiness = 19,
    StatesPromotions = 19,
    StatusRequests = 23,
    MotivoProductosRequest = 28,
    MotivoLiquidations = 66,
    MotivoProductos = 62,
    StatusLending = 33,
    StatusAmortizationRequests = 57,
    TrayectoLending = 54,
    StatuLiquidationRequests = 57,
    StatusBajaColaborador = 72,
    TypesPurchasePromotions = 78,
    TypesDiscountPromotions = 81,
    TypesQuestionsEvaluationCourses = 93,
    StatusRafles = 96,//Estados Sorteos
    TypesNotificationTemplate = 112,
    LendingFileTypes = 43,
    ReasonRejectionRequest = 136
}
export enum eReason {
    Quota = 63,
    Amortizacion = 64,
    Cese = 65,
}

export enum eStatusUser {
    Active = 5,
    Inactive = 6,
    Suspend = 7
}

export enum eTypeAuditoria {
    UpdateAdminBusiness = 13,
    UpdateAdminIpay = 14,
}

export enum eReasonUser {
    Laborando = 2,
    DeBaja = 3,
    Vacaciones = 4,
    Licencia = 5,
    Medico = 6,
    Investigacion = 7,
    Otros = 8
}

export enum eTypeProduct {
    Prestamo = 2,
    Adelanto = 3,
}

export enum eStatusLendingRequest {
    Pending = 24,
    Approved = 25,
    Disbursed = 26,
    Rejected = 27,
    Cancelled = 37
}

export enum eCountry {
    Peru = 1
}
export enum eCurrency {
    Soles = 1
}

export enum eTypeActionConfirmDialog {
    Success = 'success',
    Warning = 'warning',
    Danger = 'danger'
}

export enum eTypeUpdateAuditoria {
    AdminBusiness = 13,
    AdminIpay = 14
}
export enum eStatusBusiness {
    Activo = 16,
    Inactivo = 17,
    Suspendido = 18,
}
export enum eStatusGrupoBusiness {
    Activo = 20,
    Inactivo = 21
}

export enum ePathStorage {
    Business = "businesses/logos",
    GroupBusiness = "business_groups/logos",
    LendingDocuments = "lendings/documents",
    Comerces = "commerces",
    Promotions = "promotions",
    Courses = "course_image",
    Raffles = "raffles",
    Banks = "banks",
}

export enum eTypeAdelantoSueldo {
    Transaccional = 1,
    Suscripcion = 2,
}

export enum eTypePayrollSoftware {
    Adapta = 1,
    Ofisis = 2,
}

export enum eStatusQuotaLending {
    Pagado = 48,
    PorPagar = 49,
    Cancelado = 50,
    Liquidado = 59,
    strPagado = "Pagado",
    strPorPagar = "Por pagar",
    strCancelado = "Cancelado",
}


export enum eStatusLendingLiquidation {
    Pendiente = 58,
    Aprobado = 59,
    Rechazado = 60,
    Pagado = 73,
    PendienteVoucher = 74,
}

export enum eStatusBajaColaborador {
    Pendiente = 75,
    Aprobado = 76,
    Rechazado = 77,
}
export enum eTypeDescount {
    Amount = 83,
    Percentage = 82
}

export enum eDefaultsGenerateInvoice {
    TipoComprobante = 2,
    Serie = "BBB1"
}

export enum eTypeQuestionEvaluationCourse {
    RespuestaUnica = 1,
    VerdaderoFalso = 2,
    RespuestaMultiple = 2,
}

export enum eStatusRaffles {
    Activo = 97,
    Inactivo = 98,
    Borrador = 99,
    Programado = 100,
    Finalizado = 101
}

export enum eTypeNotificationTemplate {
    Info = 113,
    Success = 114,
    Warning = 115,
    Error = 116,
    Help = 146,
}

export enum eMethodPayment {
    Yape = 125,
    Plin = 126,
}

export enum eTransactions {
    ParticipacionSorteo = 103,
    CreditoCanjeTokens = 117,
    PremioSorteo = 118,
    AjusteManualBonificacion = 119,
    CanjeTokensAPuntos = 121,
    CompraTokens = 122,
}

export enum eTypeWinner {
    PendienteEntrega = 129,
    EnProceso = 131,
    Entregado = 130,
    SinGanadorEstablecido = 132
}

export enum eTypeLendingFile {
    ComprobateDesembolso = 44,
    Cuota = 45,
    Otro = 46,
    Liquidacion = 61,
    Contrato = 69,
    CartaNoAdeudo = 70,
    ComprobanteDesembolso = 135,
    LiquidacionRestante = 147
}

// Bancos de origen (cuentas propias de iPay en bank_account) con reglas
// especiales en el diálogo de desembolso. Ids reales, iguales en prod/dev.
export enum eOriginBankId {
    Bcp = 6,
    Interbank = 11,
    Bbva = 3
}

export enum eCommissionTypeId {
    Interbancaria = 1,
    Interplaza = 2
}

export enum eTypeEmailLendingRequest {
    Approved = "APROBADO",
    Rejected = "RECHAZADO"
}

export enum eStatusPaymentLiquidation {
    // Pending = 0,
    Approved = 1,
    AmountRest = 0
}